import { render } from "./StudentGovernmentActivitySocial.vue?vue&type=template&id=686e9cd6"
import script from "./StudentGovernmentActivitySocial.vue?vue&type=script&lang=js"
export * from "./StudentGovernmentActivitySocial.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__